import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

window.React = React;

export class AlbumResults extends Component {
  render() {
    let albums = this.props.albums.map((album) => {
      return <a className={this.props.have_articles ? "album-result" : "album-result half"} href={album.path} key={album.path}>
          <div className='album-image'><img src={album.image} alt={album.title} /></div>
          <div>{album.title}</div>
        </a>
    })
    if (albums.length > 0) {
      return <div className={this.props.have_articles ? "col-md-6 col-12" : "col-12"}>
          <b className="result-label">Albums</b>
          <div className="row album-results">
            { albums }
          </div>
        </div>
    }
    else {
      return null
    }
  }
}

export class ArticleResults extends Component {
  render() {
    let articles = this.props.articles.map((article) => {
      return <a className="article-result" href={article.path} key={article.path}>{article.title}</a>
    })
    if (articles.length > 0) {
    return <div className={this.props.have_albums ? "col-md-6 col-12" : "col-12" }>
      <b className="result-label">Articles</b>
      <div className="row col-12 article-results">
          { articles }
      </div>
      </div>
    } else {
      return null
    }
  }
}

export class SearchBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
      showResults: false,
      timeout: null,
      text: '',
      albums: [],
      articles: [],
      completed: false
    }
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      // clicked outside
      // this.toggleShow()
    }
  }

  toggleShow(){
    this.setState({ show: !this.state.show })
  }

  clearText(){
    document.querySelector(".search-text-input").value = '';
    this.setState({
      showResults: false,
      text: '',
      albums: [],
      articles: [],
    })
  }

  componentDidMount() {
    $("#search").click(() => {
      this.toggleShow()
    })
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    $("#search").off("click")
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  onChange(event){
    clearTimeout(this.state.timeout)
    this.setState({ text: event.target.value })
    this.setState({ timeout: setTimeout(() => {
        // call API here
        this.setState({ completed: false })
        if (this.state.text.length > 2 || (this.state.text.match(/[\u3400-\u9FBF]/) && this.state.text.length > 1)){

          let data = {}
          data["q"] = this.state.text
          this.setState({ showResults: true })

          $.ajax({
            url: this.props.url,
            data: data,
            dataType: 'json',
            type: 'GET',

            success: data => {
              this.setState({ albums: data.albums, articles: data.articles, completed: true })
            },

            error: (xhr, status, err) => {
              console.error(this.props.url, status, err.toString())
            }
          });
        } else {
          this.setState({ showResults: false })
        }
      }, 500)
    })
  }


  render() {

    let style = {
      "backgroundColor": this.props.color
    }

    let search_loading  = this.state.completed ?
      <div className="row mx-0">
        { this.props.mobile &&
          <span className="fa-stack fa-lg search-text-close-mobile" onClick={() => this.clearText() }>
            <i className="fas fa-times"></i>
          </span>}
        <AlbumResults albums={this.state.albums} have_articles={this.state.articles.length > 0} />
        <ArticleResults articles={this.state.articles} have_albums={this.state.albums.length > 0} />
      </div>
      : <div className="search-loading"></div>

    let search_results = this.state.showResults ?
      <div className="search-results">
        { search_loading }
      </div> : null

    if (this.state.show)
      return <div className="search-text" style={style} ref={this.setWrapperRef}>
          <input type="text" onChange={this.onChange.bind(this)} className="search-text-input" placeholder="Type to Search.." autoFocus="true" style={style}></input>
          { !this.props.mobile &&
          <span className="fa-stack fa-lg search-text-close" onClick={() => this.toggleShow() }>
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className="fas fa-times fa-stack-1x fa-inverse"></i>
          </span> }
          { search_results }
        </div>
    else
      return null
  }
}